import type { SelectedItemRenderProps } from '@openx/components-core/lib/SelectionDrawer/types';
import type { ListCountriesQuery } from '../../../../../../../../graphql/fragment/audiences/ListCountries.generated';
import type { ListRegionsQuery } from '../../../../../../../../graphql/fragment/audiences/ListRegions.generated';
import type { FormSegment, LookalikeFormSegment } from '../../../../../types';
import type { LookalikeDefinitionSegments } from '../hooks/lookalike/lookalikeSegmentsReducer';
import { SelectedLookalikeItem } from './SelectedSegmentsList/SelectedLookalikeItem';
import { SelectedSegmentItem as OriginalSelectedSegmentItem } from './SelectedSegmentsList/SelectedSegmentItem';

type SelectedSegmentItemProps = SelectedItemRenderProps<FormSegment | LookalikeDefinitionSegments> & {
  onEditLookalike?: (segment: LookalikeFormSegment) => void;
  regions: ListRegionsQuery['region'];
  countries: ListCountriesQuery['country'];
};

const isLookalikeDefinition = (item: unknown): item is LookalikeDefinitionSegments => {
  return typeof item === 'object' && item !== null && ('similaritySegment' in item || 'seedSegment' in item);
};

const isFormSegment = (item: FormSegment | LookalikeDefinitionSegments): item is FormSegment => {
  return !isLookalikeDefinition(item);
};

export const SelectedSegmentItemAdapter = ({
  item,
  onRemove,
  onEditLookalike,
  regions,
  countries,
}: SelectedSegmentItemProps) => {
  if (isLookalikeDefinition(item)) {
    return (
      <SelectedLookalikeItem definition={item} onRemove={() => onRemove(item)} onEditLookalike={onEditLookalike} />
    );
  }

  if (isFormSegment(item)) {
    return (
      <OriginalSelectedSegmentItem
        segment={item}
        onRemove={() => onRemove(item)}
        regions={regions}
        countries={countries}
      />
    );
  }

  return null;
};
